












































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { selectTree, dataPageSave } from '@/api/tenant/dataPage'
import { changeAvatarUrl } from '@/api/users'
import Draggable from 'vuedraggable'
@Component({
  components: {
    Draggable
  }
})
export default class Add extends Vue {
  @Prop() addData !: {} | null
  changeAvatarUrl = changeAvatarUrl;
  activeName = 'base';
  form: {
     title: string;
    intro: string;
    pic: string;
    remark: string;
  } = {
    title: '',
    intro: '',
    pic: '',
    remark: ''
  };

  defaultProps = {
    children: 'children',
    label: 'label'
  };

  trees = [];
  treesClone = [];
  selectArr: string[] = [];
  expanded: string[] = [];
  showCheckoutList: string[] = [];
  uploadHeader = {
    Authorization: 'bearer ' + window.sessionStorage.getItem('token'),
    tenantId: window.sessionStorage.getItem('tenantId')
  };

  created() {
    this.show(this.addData)

  }

  private async getSelectTree (data: any) {
    const trees: any = []
    const selectArr = []
    const expanded = []
    const _data = cloneDeep(data.trees)
    for (let i = 0; i < _data.length; i++) {
      const tree = _data[i]
      const obj: any = {
        key: tree.rootType,
        label: tree.rootType,
        children: []
      }
      for (const k in tree.branch) {
        const _children = []
        for (let j = 0; j < tree.branch[k].length; j++) {
          const _subTree = tree.branch[k][j]
          if (_subTree.selected === true) {
            selectArr.push(_subTree.name)
          }
          _children.push({
            ..._subTree,
            label: _subTree.name
          })
        }
        expanded.push(k)
        obj.children.push({
          label: k,
          children: _children
        })
      }
      trees.push(obj)
    }
    this.treesClone = cloneDeep(data.trees)
    this.trees = trees
    this.selectArr = selectArr
    this.showCheckoutList = cloneDeep(selectArr)
    this.expanded = expanded
  }

  handleCheckChange (node: any, checkStatus: boolean) {
    if (checkStatus) {
      if (!node.children) {
        this.showCheckoutList.push(node.label)
      }
    } else {
      if (!node.children) {
        const _index = this.showCheckoutList.findIndex((item: any) => item === node.label)
        this.showCheckoutList.splice(_index, 1)
      }
    }
  }

  private async show (editInfo: any) {
    if (editInfo) {
      this.form = editInfo
      this.getSelectTree(editInfo.economicIndicatorMap)
    } else {
      const { data } = await selectTree()
      this.getSelectTree(data)
    }
  }

  private async confirm () {
    const { form, showCheckoutList } = this
    const _form: {
      economicIndicatorList: string[];
      // eslint-disable-next-line @typescript-eslint/member-delimiter-style
      economicIndicatorMap?: {}
    } = {
      ...cloneDeep(form),
      economicIndicatorList: showCheckoutList
    }
    delete _form.economicIndicatorMap

    await dataPageSave(_form)
    this.$message({
      type: 'success',
      message: '更新成功'
    })
    this.$emit('on-close', true)
  }



  handleAvatarSuccess (res: {
     data: string;
  }) {
    this.form.pic = res.data
  }
}
